import { useTranslationsStore } from '@/stores/translationsStore';

export default {
  install(app) {
    app.config.globalProperties.__TT = (key, params = {}) => {
      const translationStore = useTranslationsStore();
      return translationStore.translate(key, params);
    };
  },
};
